import { STORAGE_KEYS } from '@/shared/constants/common';
export const getCookie = (name) => {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i += 1) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }
    return null;
};
export const setCookie = (name, value, days = 7) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
};
export const deleteCookie = (name) => {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/; domain=.realush.com`;
};
export const extractAndSaveTokenFromCookies = () => {
    const possibleTokenNames = ['X-Access-Token'];
    let tokenFound = false;
    possibleTokenNames.forEach((tokenName) => {
        if (!tokenFound) {
            const token = getCookie(tokenName);
            if (token) {
                localStorage.setItem(STORAGE_KEYS.accessToken, token);
                localStorage.setItem(STORAGE_KEYS.accessTokenTimestamp, Date.now().toString());
                tokenFound = true;
            }
        }
    });
    return tokenFound;
};
export const extractErrorFromCookies = () => {
    const possibleErrorNames = ['Error-Code'];
    let errorValue = null;
    possibleErrorNames.some((errorName) => {
        const value = getCookie(errorName);
        if (value) {
            errorValue = value;
            deleteCookie(errorName);
            return true;
        }
        return false;
    });
    return errorValue;
};
